<template>
  <div class="card w-100 bg-base-100 card-bordered">
    <div class="card-body">
      <h2 class="card-title justify-center mb-4">Login</h2>
      
      <form @submit.prevent="handleLogin" class="space-y-4">
        <div class="form-control">
          <label class="label">
            <span class="label-text">Email</span>
          </label>
          <input
            v-model="form.email"
            type="email"
            placeholder="your@email.com"
            class="input input-bordered"
            :class="{ 'input-error': errors.email }"
            required
          />
          <label v-if="errors.email" class="label">
            <span class="label-text-alt text-error">{{ errors.email }}</span>
          </label>
        </div>

        <div class="form-control">
          <label class="label">
            <span class="label-text">Password</span>
          </label>
          <input
            v-model="form.password"
            type="password"
            placeholder="Enter your password"
            class="input input-bordered"
            :class="{ 'input-error': errors.password }"
            required
          />
          <label v-if="errors.password" class="label">
            <span class="label-text-alt text-error">{{ errors.password }}</span>
          </label>
        </div>

        <div v-if="error" class="alert alert-error">
          <span>{{ error }}</span>
        </div>

        <div class="form-control mt-6">
          <button
            type="submit"
            class="btn btn-primary"
            :disabled="loading"
          >
            <span v-if="loading" class="loading loading-spinner loading-sm"></span>
            {{ loading ? 'Logging in...' : 'Login' }}
          </button>
        </div>
      </form>

      <div class="divider">OR</div>
      
      <div class="text-center">
        <p class="text-sm text-gray-600">
          Don't have an account?
          <button @click="$emit('switch-to-register')" class="link link-primary">
            Register here
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

export default {
  name: 'LoginForm',
  emits: ['switch-to-register'],
  setup() {
    const authStore = useAuthStore()
    const router = useRouter()
    
    const form = reactive({
      email: '',
      password: ''
    })
    
    const errors = reactive({
      email: '',
      password: ''
    })
    
    const error = ref('')
    const loading = ref(false)

    const validateForm = () => {
      errors.email = ''
      errors.password = ''
      
      if (!form.email) {
        errors.email = 'Email is required'
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
        errors.email = 'Please enter a valid email'
      }
      
      if (!form.password) {
        errors.password = 'Password is required'
      }
      
      return !errors.email && !errors.password
    }

    const handleLogin = async () => {
      if (!validateForm()) return
      loading.value = true
      error.value = ''
      try {
        await authStore.login(form.email, form.password)
        // Redirect after successful login
        router.push('/')
      } catch (err) {
        error.value = err.message || 'Login failed. Please try again.'
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      errors,
      error,
      loading,
      handleLogin
    }
  }
}
</script> 